import ES6Promise from 'es6-promise';
import 'whatwg-fetch'
import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';

ES6Promise.polyfill();

const searchBaseURL = "https://platform.edgefolio.com/api/search/public/funds/?keyword=";
const profileBaseURL = "https://platform.edgefolio.com/app/funds/";

const findFunds = inputValue => {
    return fetch(searchBaseURL + inputValue)
        .then(res => res.json())
};

const promiseOptions = inputValue =>
      new Promise(resolve => {
          resolve(findFunds(inputValue));
      });

const noOptionsMessage = () => {
    return null;
}

const onChange = (value) => {
    window.location.assign(profileBaseURL + value.value)
}

export default class WithPromises extends Component {
    render() {
        return (
                <AsyncSelect
                    cacheOptions
                    defaultOptions
                    autoFocus
                    loadOptions={promiseOptions}
                    placeholder="Search by name, manager, strategy, or anything else!"
                    noOptionsMessage={noOptionsMessage}
                    isClearable = {true}
                    onChange={onChange}
                    components={
                        {
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null
                        }
                    }
                />
        );
    }
}
